import { Eyebrow, Reveal } from "../components/Reveal";
import { WhatsAppIcon } from "../components/icons";
import { CONTACT_EMAIL, WHATSAPP_DISPLAY, waLink } from "../data/site";

export const Contato = () => (
  <section id="contato" data-testid="contato-section" className="relative scroll-mt-24 overflow-hidden bg-[#0B0F14]/70 py-32 lg:py-44">
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[560px] w-[860px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#007BFF]/[0.13] blur-[130px]" />
    <div className="relative mx-auto max-w-4xl px-6 text-center lg:px-10">
      <Reveal>
        <Eyebrow>05 · Contato</Eyebrow>
        <h2 className="mt-6 text-3xl font-semibold leading-tight tracking-tight text-slate-50 sm:text-4xl lg:text-6xl">
          Seu negócio pode rodar no automático.
          <span className="text-[#3a9bff]"> Vamos conversar?</span>
        </h2>
        <p className="mx-auto mt-7 max-w-xl text-base leading-relaxed text-slate-400 sm:text-lg">
          Solicite um teste grátis direto pelo WhatsApp e veja a automação
          funcionando antes de decidir. Sem formulário, sem compromisso.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <a
          href={waLink("Olá! Vim pelo site da AMB Solutions e quero solicitar um teste grátis.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contato-whatsapp-cta"
          className="group mt-12 inline-flex items-center gap-3 rounded-full bg-[#007BFF] px-10 py-5 text-base font-semibold text-white transition-shadow duration-300 hover:shadow-[0_0_50px_rgba(0,123,255,0.65)]"
        >
          <WhatsAppIcon className="h-5 w-5 transition-transform duration-300 group-hover:scale-110" />
          Solicitar teste grátis pelo WhatsApp
        </a>
        <p className="mt-7 text-sm tracking-[0.2em] text-slate-500" data-testid="contato-phone">
          {WHATSAPP_DISPLAY}
          <span className="mx-3 text-slate-700">·</span>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="contato-email" className="tracking-normal transition-colors duration-300 hover:text-white">
            {CONTACT_EMAIL}
          </a>
        </p>
      </Reveal>
    </div>
  </section>
);
